var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundEffects = function SvgSoundEffects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.917,
    d: "M20.167 1.333v5.083m2.541-2.541h-5.083M13 3.666 6.333 9H1v8h5.333L13 22.333zm17.783 11.981c-3.483-.001-6.309-2.821-6.33-6.308-.022 3.483-2.842 6.3-6.32 6.308 3.49.008 6.318 2.846 6.32 6.347 0-3.505 2.834-6.345 6.33-6.347"
  })));
};
export default SvgSoundEffects;